'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const rulesets = {
    all: {
        value: 'all',
        name: 'All',
        tags: [],
        bestPracticeTags: [],
        type: 'ALL',
        engineSupport: {
            'axe-core': '*'
        }
    },
    wcag22aaa: {
        value: 'wcag22aaa',
        name: 'WCAG 2.2 AAA',
        tags: [
            'wcag22aaa',
            'wcag22aa',
            'wcag22a',
            'wcag21aaa',
            'wcag21aa',
            'wcag21a',
            'wcag2aaa',
            'wcag2aa',
            'wcag2a'
        ],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '>=4.5.0'
        }
    },
    wcag22aa: {
        value: 'wcag22aa',
        name: 'WCAG 2.2 AA',
        tags: ['wcag22aa', 'wcag22a', 'wcag21aa', 'wcag21a', 'wcag2aa', 'wcag2a'],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '>=4.5.0'
        }
    },
    wcag22a: {
        value: 'wcag22a',
        name: 'WCAG 2.2 A',
        tags: ['wcag22a', 'wcag21a', 'wcag2a'],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '>=4.5.0'
        }
    },
    wcag21aaa: {
        value: 'wcag21aaa',
        name: 'WCAG 2.1 AAA',
        tags: ['wcag21aaa', 'wcag21aa', 'wcag21a', 'wcag2aaa', 'wcag2aa', 'wcag2a'],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '>=3.1.0'
        }
    },
    wcag21aa: {
        value: 'wcag21aa',
        name: 'WCAG 2.1 AA',
        tags: ['wcag21aa', 'wcag21a', 'wcag2aa', 'wcag2a'],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '>=3.1.0'
        }
    },
    wcag21a: {
        value: 'wcag21a',
        name: 'WCAG 2.1 A',
        tags: ['wcag21a', 'wcag2a'],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '>=3.1.0'
        }
    },
    wcag2aaa: {
        value: 'wcag2aaa',
        name: 'WCAG 2.0 AAA',
        tags: ['wcag2aaa', 'wcag2aa', 'wcag2a'],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '*'
        }
    },
    wcag2aa: {
        value: 'wcag2aa',
        name: 'WCAG 2.0 AA',
        tags: ['wcag2aa', 'wcag2a'],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '*'
        }
    },
    wcag2a: {
        value: 'wcag2a',
        name: 'WCAG 2.0 A',
        tags: ['wcag2a'],
        bestPracticeTags: ['best-practice'],
        type: 'WCAG',
        engineSupport: {
            'axe-core': '*'
        }
    },
    TTv5: {
        value: 'TTv5',
        name: 'Trusted Tester v5',
        tags: ['TTv5'],
        bestPracticeTags: ['best-practice'],
        type: 'Trusted Tester',
        engineSupport: {
            'axe-core': '>=4.7.0'
        }
    },
    'EN-301-549': {
        value: 'EN-301-549',
        name: 'EN 301 549',
        tags: ['EN-301-549'],
        bestPracticeTags: ['best-practice'],
        type: 'EN',
        engineSupport: {
            'axe-core': '>=4.8.0'
        }
    },
    RGAAv4: {
        value: 'RGAAv4',
        name: 'RGAA 4',
        tags: ['RGAAv4'],
        bestPracticeTags: [
            'best-practice',
            'wcag21aa',
            'wcag21a',
            'wcag2aa',
            'wcag2a'
        ],
        type: 'RGAA',
        engineSupport: {
            'axe-core': '>=4.11.0'
        }
    }
};

/**
 * Central metadata for every WCAG success criterion referenced by the mobile
 * rules: the WCAG version that introduced it and its W3C spec anchor slug.
 * Keeping it here means the version/spec-link mapping is maintained in one
 * place rather than repeated on each rule.
 *
 * `version` is the version that *introduced* the criterion (canonical), which
 * may differ from a per-rule label in the docs — e.g. `4.1.2` is a 2.0
 * criterion even where a docs page tags a rule "2.1".
 *
 * `specUrl` links to the WCAG Recommendation that *introduced* the criterion
 * (`2.0` → `/TR/WCAG20/`, `2.1` → `/TR/WCAG21/`, `2.2` → `/TR/WCAG22/`), so the
 * link matches the `version` label. Because of that, the anchor `slug` is
 * version-specific: WCAG 2.0 uses legacy anchors (e.g. `1.1.1` is
 * `text-equiv-all`, not the `non-text-content` slug used from 2.1 on), and some
 * criteria were re-anchored between versions (e.g. `2.5.5` is `target-size` in
 * 2.1 but `target-size-enhanced` in 2.2). Each slug below is the anchor as it
 * appears in that criterion's introducing spec.
 */
const SPEC_BASE_URL = {
    '2.0': 'https://www.w3.org/TR/WCAG20',
    '2.1': 'https://www.w3.org/TR/WCAG21',
    '2.2': 'https://www.w3.org/TR/WCAG22'
};
const WCAG_CRITERIA = {
    '1.1.1': { version: '2.0', slug: 'text-equiv-all' },
    '1.3.2': { version: '2.0', slug: 'content-structure-separation-sequence' },
    '1.3.4': { version: '2.1', slug: 'orientation' },
    '1.4.3': { version: '2.0', slug: 'visual-audio-contrast-contrast' },
    '1.4.4': { version: '2.0', slug: 'visual-audio-contrast-scale' },
    '2.1.1': { version: '2.0', slug: 'keyboard-operation-keyboard-operable' },
    '2.4.2': { version: '2.0', slug: 'navigation-mechanisms-title' },
    '2.5.3': { version: '2.1', slug: 'label-in-name' },
    '2.5.5': { version: '2.1', slug: 'target-size' },
    '2.5.8': { version: '2.2', slug: 'target-size-minimum' },
    '4.1.2': { version: '2.0', slug: 'ensure-compat-rsv' }
};
/**
 * Build a `WcagCriterion` for a success criterion number + conformance level,
 * filling in the version, human-readable guideline, and W3C spec link from the
 * central `WCAG_CRITERIA` table.
 */
const wcagCriterion = (criterion, level) => {
    const meta = WCAG_CRITERIA[criterion];
    if (!meta) {
        throw new Error(`Unknown WCAG success criterion: ${criterion}`);
    }
    return {
        version: meta.version,
        criterion,
        level,
        guideline: `WCAG ${meta.version} ${criterion} ${level}`,
        specUrl: `${SPEC_BASE_URL[meta.version]}/#${meta.slug}`
    };
};

/**
 * Canonical Android mobile accessibility rules.
 */
const androidRules = {
    'android-active-view-name': {
        value: 'android-active-view-name',
        sdkRuleId: 'ActiveViewName',
        auditorRuleId: 'control-name-inaccessible',
        name: 'Active View Name',
        description: 'Any interactive view should have an accessible name available for assistive technologies such as TalkBack and Voice Access.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('4.1.2', 'A')]
    },
    'android-checkbox-name': {
        value: 'android-checkbox-name',
        sdkRuleId: 'CheckBoxName',
        auditorRuleId: 'control-name-inaccessible',
        name: 'CheckBox Name',
        description: 'Any CheckBox element should have an accessible name available for assistive technologies such as TalkBack and Voice Access.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('4.1.2', 'A')]
    },
    'android-color-contrast': {
        value: 'android-color-contrast',
        sdkRuleId: 'ColorContrast',
        auditorRuleId: 'contrast-text-4.5-1',
        name: 'Color Contrast',
        description: 'Ensures that each text element has a minimum 4.5:1 contrast ratio with its background and that large text has a minimum 3.0:1 contrast ratio.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('1.4.3', 'AA')]
    },
    'android-edit-text-name': {
        value: 'android-edit-text-name',
        sdkRuleId: 'EditTextName',
        auditorRuleId: 'control-name-inaccessible',
        name: 'Edit Text Name',
        description: 'Text input elements should have an accessible name available for assistive technologies such as TalkBack and Voice Access.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('4.1.2', 'A')]
    },
    'android-edit-text-value': {
        value: 'android-edit-text-value',
        sdkRuleId: 'EditTextValue',
        auditorRuleId: 'android-control-edit-text',
        name: 'Edit Text Value',
        description: 'Text input elements should have their value available for assistive technologies such as TalkBack and Voice Access.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('4.1.2', 'A')]
    },
    'android-focusable-text': {
        value: 'android-focusable-text',
        sdkRuleId: 'FocusableText',
        auditorRuleId: 'reading-order-content-skipped',
        name: 'Focusable Text',
        description: 'Views containing text should be focusable for assistive technologies such as TalkBack.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('1.3.2', 'A')]
    },
    'android-image-view-name': {
        value: 'android-image-view-name',
        sdkRuleId: 'ImageViewName',
        auditorRuleId: 'alt-text-missing',
        name: 'ImageView Name',
        description: 'Focusable image elements should provide a meaningful accessible name available for assistive technologies such as TalkBack and Voice Access.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('1.1.1', 'A')]
    },
    'android-inaccessible-action': {
        value: 'android-inaccessible-action',
        sdkRuleId: 'InaccessibleAction',
        auditorRuleId: 'keyboard-not-touch-accessible',
        name: 'Inaccessible Action',
        description: 'Interactive views should be focusable with assistive technology.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('2.1.1', 'A')]
    },
    'android-label-at-front': {
        value: 'android-label-at-front',
        sdkRuleId: 'LabelAtFront',
        auditorRuleId: 'speech-accessible-name-other-words-before',
        name: 'Label At Front',
        description: 'Any visible text of an interactive element should be at the start of the element’s accessible name.',
        categories: ['best-practice'],
        impact: 'minor',
        wcagCriteria: []
    },
    'android-label-in-name': {
        value: 'android-label-in-name',
        sdkRuleId: 'LabelInName',
        auditorRuleId: 'speech-accessible-name-mismatch',
        name: 'Label In Name',
        description: 'An interactive element’s visible label should match its name property.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('2.5.3', 'A')]
    },
    'android-nested-focusable-element': {
        value: 'android-nested-focusable-element',
        sdkRuleId: 'NestedFocusableElement',
        name: 'Nested Focusable Element',
        description: 'Focusable elements should not be nested within clickable parent elements.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('4.1.2', 'A')]
    },
    'android-screen-orientation': {
        value: 'android-screen-orientation',
        sdkRuleId: 'ScreenOrientation',
        auditorRuleId: 'orientation-current',
        name: 'Screen Orientation',
        description: 'Views should adhere to the user’s preferred display orientation.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('1.3.4', 'AA')]
    },
    'android-screen-title': {
        value: 'android-screen-title',
        sdkRuleId: 'ScreenTitle',
        auditorRuleId: 'title-missing-native-mobile',
        name: 'Screen Title',
        description: 'Every screen within an application should provide a title to be announced by assistive technology.',
        categories: [],
        impact: 'moderate',
        wcagCriteria: [wcagCriterion('2.4.2', 'A')]
    },
    'android-switch-name': {
        value: 'android-switch-name',
        sdkRuleId: 'SwitchName',
        auditorRuleId: 'control-name-inaccessible',
        name: 'Switch Name',
        description: 'Any Switch element should have an accessible name available for assistive technologies such as TalkBack and Voice Access.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('4.1.2', 'A')]
    },
    'android-touch-target-size': {
        value: 'android-touch-target-size',
        sdkRuleId: 'TouchTargetSize',
        legacySdkRuleIds: ['TouchSizeWcag'],
        auditorRuleId: 'touch-size-small',
        name: 'Touch Target Size',
        description: 'All active controls should have a minimum of 44dp by 44dp visual and tappable area.',
        categories: [],
        impact: 'moderate',
        wcagCriteria: [wcagCriterion('2.5.5', 'AAA')]
    },
    'android-touch-target-spacing': {
        value: 'android-touch-target-spacing',
        sdkRuleId: 'TouchTargetSpacing',
        auditorRuleId: 'target-size-small',
        name: 'Touch Target Spacing',
        description: 'Actionable controls should have a minimum dimension of 24 x 24 dp or must be positioned so that if a circle with a diameter of 24 dp is placed on the center of control, the circle will not intersect with another target or with the circle for another target.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('2.5.8', 'AA')]
    }
};

/**
 * Canonical iOS mobile accessibility rules.
 */
const iosRules = {
    'a11y-element-focus-box': {
        value: 'a11y-element-focus-box',
        sdkRuleId: 'A11yElementFocusBox',
        auditorRuleId: 'reading-order-visual-order-mismatch',
        name: 'A11y Element Focus Box',
        description: 'Ensures a view’s accessibility path, or VoiceOver focus box, encapsulates its own visual on-screen frame.',
        categories: ['best-practice'],
        impact: 'moderate',
        wcagCriteria: []
    },
    'active-control-name': {
        value: 'active-control-name',
        sdkRuleId: 'ActiveControlName',
        auditorRuleId: 'control-name-inaccessible',
        name: 'Active Control Name',
        description: 'Any interactive view should have an accessible name available for assistive technologies such as VoiceOver and Voice Control.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('4.1.2', 'A')]
    },
    'associated-text': {
        value: 'associated-text',
        sdkRuleId: 'AssociatedText',
        auditorRuleId: 'form-field-missing-label',
        name: 'Associated Text',
        description: 'A control should get its accessible name from a nearby label available for assistive technologies such as VoiceOver and Voice Control.',
        categories: [],
        // Docs list "Critical or Serious"; using the higher severity.
        impact: 'critical',
        wcagCriteria: [wcagCriterion('4.1.2', 'A')]
    },
    'clipped-text': {
        value: 'clipped-text',
        sdkRuleId: 'ClippedText',
        name: 'Clipped Text',
        description: 'Static text must not clip its visible content at its current state or when it is resized.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('1.4.4', 'AA')]
    },
    'colliding-views': {
        value: 'colliding-views',
        sdkRuleId: 'CollidingViews',
        auditorRuleId: 'reading-order-visual-order-mismatch',
        name: 'Colliding Views',
        description: 'Views containing information should not intersect with another view, either entirely or partially.',
        categories: ['best-practice'],
        impact: 'minor',
        wcagCriteria: []
    },
    'color-contrast': {
        value: 'color-contrast',
        sdkRuleId: 'ColorContrast',
        auditorRuleId: 'contrast-text-4.5-1',
        name: 'Color Contrast',
        description: 'Ensures that each text element has a minimum 4.5:1 contrast ratio with its background and that large text has a minimum 3.0:1 contrast ratio.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('1.4.3', 'AA')]
    },
    'conflicting-traits': {
        value: 'conflicting-traits',
        sdkRuleId: 'ConflictingTraits',
        auditorRuleId: 'control-incorrect-role',
        name: 'Conflicting Traits',
        description: 'Views should not have conflicting accessibility traits.',
        categories: ['best-practice'],
        impact: 'critical',
        wcagCriteria: []
    },
    'focusable-text': {
        value: 'focusable-text',
        sdkRuleId: 'FocusableText',
        auditorRuleId: 'reading-order-content-skipped',
        name: 'Focusable Text',
        description: 'Views containing text should be focusable for assistive technologies such as VoiceOver.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('1.3.2', 'A')]
    },
    'imageview-name': {
        value: 'imageview-name',
        sdkRuleId: 'ImageViewName',
        auditorRuleId: 'alt-text-missing',
        name: 'ImageView Name',
        description: 'Focusable image elements should provide a meaningful accessible name available for assistive technologies such as VoiceOver and Voice Control.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('1.1.1', 'A')]
    },
    'in-scrollview': {
        value: 'in-scrollview',
        sdkRuleId: 'InScrollView',
        auditorRuleId: 'resize-text-content-lost-mobile',
        name: 'In ScrollView',
        description: 'Text should be within scrollable areas to ensure that all content is visible on all screen sizes.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('1.4.4', 'AA')]
    },
    'inaccessible-action': {
        value: 'inaccessible-action',
        sdkRuleId: 'InaccessibleAction',
        auditorRuleId: 'keyboard-not-touch-accessible',
        name: 'Inaccessible Action',
        description: 'An interactive view should have the ability to be activated with assistive technology.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('2.1.1', 'A')]
    },
    'label-at-front': {
        value: 'label-at-front',
        sdkRuleId: 'LabelAtFront',
        auditorRuleId: 'speech-accessible-name-other-words-before',
        name: 'Label At Front',
        description: 'Any visible text of an interactive element should be at the start of the element’s accessible name.',
        categories: ['best-practice'],
        impact: 'minor',
        wcagCriteria: []
    },
    'label-in-name': {
        value: 'label-in-name',
        sdkRuleId: 'LabelInName',
        auditorRuleId: 'speech-accessible-name-mismatch',
        name: 'Label In Name',
        description: 'An interactive element’s visible label should match its name property.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('2.5.3', 'A')]
    },
    'meaningful-accessible-name': {
        value: 'meaningful-accessible-name',
        sdkRuleId: 'MeaningfulAccessibleName',
        auditorRuleId: 'button-value-text-mismatch',
        name: 'Meaningful Accessible Name',
        description: 'An element’s accessible name should not include its accessibility trait.',
        categories: ['best-practice'],
        impact: 'minor',
        wcagCriteria: []
    },
    'nested-elements-name': {
        value: 'nested-elements-name',
        sdkRuleId: 'NestedElementsName',
        auditorRuleId: 'reading-order-content-skipped',
        name: 'Nested Elements Name',
        description: 'A focusable view should have all visible text within its accessible name available to assistive technologies like VoiceOver and Voice Control.',
        categories: [],
        impact: 'critical',
        wcagCriteria: [wcagCriterion('1.3.2', 'A')]
    },
    'screen-orientation': {
        value: 'screen-orientation',
        sdkRuleId: 'ScreenOrientation',
        auditorRuleId: 'orientation-current',
        name: 'Screen Orientation',
        description: 'Views should adhere to the user’s preferred display orientation.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('1.3.4', 'AA')]
    },
    'screen-title': {
        value: 'screen-title',
        sdkRuleId: 'ScreenTitle',
        auditorRuleId: 'title-missing-native-mobile',
        name: 'Screen Title',
        description: 'Every screen within an application should provide a title to be announced by assistive technology.',
        categories: [],
        impact: 'moderate',
        wcagCriteria: [wcagCriterion('2.4.2', 'A')]
    },
    // Experimental rule being promoted to a full rule (mobile SDK team audit).
    'supports-dynamic-type': {
        value: 'supports-dynamic-type',
        sdkRuleId: 'SupportsDynamicType',
        auditorRuleId: 'resize-text-does-not-respond-mobile',
        name: 'Supports Dynamic Type',
        description: 'Text elements should have the required properties to support Dynamic Type and resize the text to the user’s device preference.',
        categories: ['best-practice', 'experimental'],
        impact: 'critical',
        wcagCriteria: []
    },
    'touch-target-size': {
        value: 'touch-target-size',
        sdkRuleId: 'TouchTargetSize',
        auditorRuleId: 'touch-size-small',
        name: 'Touch Target Size',
        description: 'All active controls should have a minimum of 44pt by 44pt visual and tappable area.',
        categories: [],
        impact: 'moderate',
        wcagCriteria: [wcagCriterion('2.5.5', 'AAA')]
    },
    'touch-target-spacing': {
        value: 'touch-target-spacing',
        sdkRuleId: 'TouchTargetSpacing',
        auditorRuleId: 'target-size-small',
        name: 'Touch Target Spacing',
        description: 'Actionable controls should have a minimum dimension of 24 x 24 points or must be positioned so that if a circle with a diameter of 24 points is placed on the center of control, the circle will not intersect with another target or with the circle for another target.',
        categories: [],
        impact: 'serious',
        wcagCriteria: [wcagCriterion('2.5.8', 'AA')]
    }
};

/**
 * Canonical iOS and Android mobile accessibility rule lists, exposed alongside
 * the WCAG `rulesets` export. Each list is keyed by the rule's SDK value.
 */
const mobileRules = { iosRules, androidRules };

function getIssueType(resultOrRuleOrTags, { accessibilityStandard }) {
    const tags = Array.isArray(resultOrRuleOrTags)
        ? resultOrRuleOrTags
        : resultOrRuleOrTags.tags;
    const ruleset = rulesets[accessibilityStandard];
    if (!ruleset) {
        throw new Error(`Unknown accessibility standard: ${accessibilityStandard}`);
    }
    const issueTags = ruleset.tags;
    const bestPracticeTags = ruleset.bestPracticeTags;
    if (issueTags.some(tag => tags.includes(tag))) {
        return 'issue';
    }
    else if (bestPracticeTags.some(tag => tags.includes(tag))) {
        return 'best-practice';
    }
    else {
        return 'ignored';
    }
}

const wcagCheckpointRegex = /^wcag(\d)(\d)(\d{1,3})(\w?)$/;
const wcagStandardRegex = /^wcag(\d{1,2})(a{1,3})$/;
const enAxeCorePattern = /^EN-(\d+)\.(\d+)\.(\d+)\.(\d+)$/i;
const enDequewayPattern = /^en301549-\d-(\d+)\.(\d+)\.(\d+)\.(\w)$/i;
const enStandardPattern = /^EN-301-549$/i;
const ttTagCheckoutPattern = /^TT-(\d+\.\w)$/;
const ttTagStandardPattern = /TTv(\d)/;
const ttAxeCoreCheckpointPattern = /^TT(\d+\.\w)$/;
const section508Pattern = /^section508\.(\d+\.\w)$/;
const rgaaStandardPattern = /^RGAAv(\d+)$/;
const rgaaAxeCoreCheckpointPattern = /^RGAA-(\d+\.\d+\.\d+)$/;
/*
  Map generated from https://github.com/act-rules/act-tools/blob/main/src/data/sc-urls.json
  Needs to be updated manually when new SCs are added to the ACT Rules
*/
const wcagData = new Map([
    [
        '1.1.1',
        {
            title: 'Non-text Content',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/non-text-content.html'
        }
    ],
    [
        '1.2.1',
        {
            title: 'Audio-only and Video-only (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-only-and-video-only-prerecorded.html'
        }
    ],
    [
        '1.2.2',
        {
            title: 'Captions (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/captions-prerecorded.html'
        }
    ],
    [
        '1.2.3',
        {
            title: 'Audio Description or Media Alternative (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-description-or-media-alternative-prerecorded.html'
        }
    ],
    [
        '1.2.4',
        {
            title: 'Captions (Live)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/captions-live.html'
        }
    ],
    [
        '1.2.5',
        {
            title: 'Audio Description (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-description-prerecorded.html'
        }
    ],
    [
        '1.2.6',
        {
            title: 'Sign Language (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/sign-language-prerecorded.html'
        }
    ],
    [
        '1.2.7',
        {
            title: 'Extended Audio Description (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/extended-audio-description-prerecorded.html'
        }
    ],
    [
        '1.2.8',
        {
            title: 'Media Alternative (Prerecorded)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/media-alternative-prerecorded.html'
        }
    ],
    [
        '1.2.9',
        {
            title: 'Audio-only (Live)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-only-live.html'
        }
    ],
    [
        '1.3.1',
        {
            title: 'Info and Relationships',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/info-and-relationships.html'
        }
    ],
    [
        '1.3.2',
        {
            title: 'Meaningful Sequence',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/meaningful-sequence.html'
        }
    ],
    [
        '1.3.3',
        {
            title: 'Sensory Characteristics',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/sensory-characteristics.html'
        }
    ],
    [
        '1.3.4',
        {
            title: 'Orientation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/orientation.html'
        }
    ],
    [
        '1.3.5',
        {
            title: 'Identify Input Purpose',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/identify-input-purpose.html'
        }
    ],
    [
        '1.3.6',
        {
            title: 'Identify Purpose',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/identify-purpose.html'
        }
    ],
    [
        '1.4.1',
        {
            title: 'Use of Color',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/use-of-color.html'
        }
    ],
    [
        '1.4.2',
        {
            title: 'Audio Control',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/audio-control.html'
        }
    ],
    [
        '1.4.3',
        {
            title: 'Contrast (Minimum)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/contrast-minimum.html'
        }
    ],
    [
        '1.4.4',
        {
            title: 'Resize text',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/resize-text.html'
        }
    ],
    [
        '1.4.5',
        {
            title: 'Images of Text',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/images-of-text.html'
        }
    ],
    [
        '1.4.6',
        {
            title: 'Contrast (Enhanced)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/contrast-enhanced.html'
        }
    ],
    [
        '1.4.7',
        {
            title: 'Low or No Background Audio',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/low-or-no-background-audio.html'
        }
    ],
    [
        '1.4.8',
        {
            title: 'Visual Presentation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/visual-presentation.html'
        }
    ],
    [
        '1.4.9',
        {
            title: 'Images of Text (No Exception)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/images-of-text-no-exception.html'
        }
    ],
    [
        '1.4.10',
        {
            title: 'Reflow',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/reflow.html'
        }
    ],
    [
        '1.4.11',
        {
            title: 'Non-text Contrast',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/non-text-contrast.html'
        }
    ],
    [
        '1.4.12',
        {
            title: 'Text Spacing',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/text-spacing.html'
        }
    ],
    [
        '1.4.13',
        {
            title: 'Content on Hover or Focus',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/content-on-hover-or-focus.html'
        }
    ],
    [
        '2.1.1',
        {
            title: 'Keyboard',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/keyboard.html'
        }
    ],
    [
        '2.1.2',
        {
            title: 'No Keyboard Trap',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/no-keyboard-trap.html'
        }
    ],
    [
        '2.1.3',
        {
            title: 'Keyboard (No Exception)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/keyboard-no-exception.html'
        }
    ],
    [
        '2.1.4',
        {
            title: 'Character Key Shortcuts',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/character-key-shortcuts.html'
        }
    ],
    [
        '2.2.1',
        {
            title: 'Timing Adjustable',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/timing-adjustable.html'
        }
    ],
    [
        '2.2.2',
        {
            title: 'Pause, Stop, Hide',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/pause-stop-hide.html'
        }
    ],
    [
        '2.2.3',
        {
            title: 'No Timing',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/no-timing.html'
        }
    ],
    [
        '2.2.4',
        {
            title: 'Interruptions',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/interruptions.html'
        }
    ],
    [
        '2.2.5',
        {
            title: 'Re-authenticating',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/re-authenticating.html'
        }
    ],
    [
        '2.2.6',
        {
            title: 'Timeouts',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/timeouts.html'
        }
    ],
    [
        '2.3.1',
        {
            title: 'Three Flashes or Below Threshold',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/three-flashes-or-below-threshold.html'
        }
    ],
    [
        '2.3.2',
        {
            title: 'Three Flashes',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/three-flashes.html'
        }
    ],
    [
        '2.3.3',
        {
            title: 'Animation from Interactions',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/animation-from-interactions.html'
        }
    ],
    [
        '2.4.1',
        {
            title: 'Bypass Blocks',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/bypass-blocks.html'
        }
    ],
    [
        '2.4.2',
        {
            title: 'Page Titled',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/page-titled.html'
        }
    ],
    [
        '2.4.3',
        {
            title: 'Focus Order',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-order.html'
        }
    ],
    [
        '2.4.4',
        {
            title: 'Link Purpose (In Context)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/link-purpose-in-context.html'
        }
    ],
    [
        '2.4.5',
        {
            title: 'Multiple Ways',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/multiple-ways.html'
        }
    ],
    [
        '2.4.6',
        {
            title: 'Headings and Labels',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/headings-and-labels.html'
        }
    ],
    [
        '2.4.7',
        {
            title: 'Focus Visible',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-visible.html'
        }
    ],
    [
        '2.4.8',
        {
            title: 'Location',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/location.html'
        }
    ],
    [
        '2.4.9',
        {
            title: 'Link Purpose (Link Only)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/link-purpose-link-only.html'
        }
    ],
    [
        '2.4.10',
        {
            title: 'Section Headings',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/section-headings.html'
        }
    ],
    [
        '2.4.11',
        {
            title: 'Focus Not Obscured (Minimum)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-not-obscured-minimum.html'
        }
    ],
    [
        '2.4.12',
        {
            title: 'Focus Not Obscured (Enhanced)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-not-obscured-enhanced.html'
        }
    ],
    [
        '2.4.13',
        {
            title: 'Focus Appearance',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/focus-appearance.html'
        }
    ],
    [
        '2.5.1',
        {
            title: 'Pointer Gestures',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/pointer-gestures.html'
        }
    ],
    [
        '2.5.2',
        {
            title: 'Pointer Cancellation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/pointer-cancellation.html'
        }
    ],
    [
        '2.5.3',
        {
            title: 'Label in Name',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/label-in-name.html'
        }
    ],
    [
        '2.5.4',
        {
            title: 'Motion Actuation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/motion-actuation.html'
        }
    ],
    [
        '2.5.5',
        {
            title: 'Target Size',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/target-size-enhanced.html'
        }
    ],
    [
        '2.5.6',
        {
            title: 'Concurrent Input Mechanisms',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/concurrent-input-mechanisms.html'
        }
    ],
    [
        '2.5.7',
        {
            title: 'Dragging Movements',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/dragging-movements.html'
        }
    ],
    [
        '2.5.8',
        {
            title: 'Target Size (Minimum)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/target-size-minimum.html'
        }
    ],
    [
        '3.1.1',
        {
            title: 'Language of Page',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/language-of-page.html'
        }
    ],
    [
        '3.1.2',
        {
            title: 'Language of Parts',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/language-of-parts.html'
        }
    ],
    [
        '3.1.3',
        {
            title: 'Unusual Words',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/unusual-words.html'
        }
    ],
    [
        '3.1.4',
        {
            title: 'Abbreviations',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/abbreviations.html'
        }
    ],
    [
        '3.1.5',
        {
            title: 'Reading Level',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/reading-level.html'
        }
    ],
    [
        '3.1.6',
        {
            title: 'Pronunciation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/pronunciation.html'
        }
    ],
    [
        '3.2.1',
        {
            title: 'On Focus',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/on-focus.html'
        }
    ],
    [
        '3.2.2',
        {
            title: 'On Input',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/on-input.html'
        }
    ],
    [
        '3.2.3',
        {
            title: 'Consistent Navigation',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/consistent-navigation.html'
        }
    ],
    [
        '3.2.4',
        {
            title: 'Consistent Identification',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/consistent-identification.html'
        }
    ],
    [
        '3.2.5',
        {
            title: 'Change on Request',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/change-on-request.html'
        }
    ],
    [
        '3.2.6',
        {
            title: 'Consistent Help',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/consistent-help.html'
        }
    ],
    [
        '3.3.1',
        {
            title: 'Error Identification',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/error-identification.html'
        }
    ],
    [
        '3.3.2',
        {
            title: 'Labels or Instructions',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/labels-or-instructions.html'
        }
    ],
    [
        '3.3.3',
        {
            title: 'Error Suggestion',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/error-suggestion.html'
        }
    ],
    [
        '3.3.4',
        {
            title: 'Error Prevention (Legal, Financial, Data)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/error-prevention-legal-financial-data.html'
        }
    ],
    [
        '3.3.5',
        {
            title: 'Help',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/help.html'
        }
    ],
    [
        '3.3.6',
        {
            title: 'Error Prevention (All)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/error-prevention-all.html'
        }
    ],
    [
        '3.3.7',
        {
            title: 'Redundant Entry',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/redundant-entry.html'
        }
    ],
    [
        '3.3.8',
        {
            title: 'Accessible Authentication (Minimum)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/accessible-authentication-minimum.html'
        }
    ],
    [
        '3.3.9',
        {
            title: 'Accessible Authentication (Enhanced)',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/accessible-authentication-enhanced.html'
        }
    ],
    [
        '4.1.1',
        {
            title: 'Parsing',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/parsing.html'
        }
    ],
    [
        '4.1.2',
        {
            title: 'Name, Role, Value',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/name-role-value.html'
        }
    ],
    [
        '4.1.3',
        {
            title: 'Status Messages',
            url: 'https://www.w3.org/WAI/WCAG22/Understanding/status-messages.html'
        }
    ]
]);
function getTagInfo(tag) {
    const { isValid, checkpoint, checkpointDescription, understandingUrl, standard } = validateTag(tag);
    if (isValid) {
        const tagInfo = {
            standard: standard,
            value: tag
        };
        if (checkpoint) {
            tagInfo.checkpoint = checkpoint;
        }
        if (checkpointDescription) {
            tagInfo.checkpointDescription = checkpointDescription; // Set the description if available
        }
        if (understandingUrl) {
            tagInfo.understandingUrl = understandingUrl; // Set the URL if available
        }
        return tagInfo;
    }
}
function validateTag(tag) {
    if (tag.startsWith('wcag')) {
        const match = wcagCheckpointRegex.exec(tag);
        if (match) {
            const [, major, minor, checkpoint, suffix] = match;
            const formattedTag = `${major}.${minor}.${checkpoint}`;
            const wcagInfo = wcagData.get(formattedTag);
            if (wcagInfo) {
                return {
                    isValid: true,
                    checkpoint: `${formattedTag}${suffix}`,
                    checkpointDescription: wcagInfo.title,
                    understandingUrl: wcagInfo.url,
                    standard: 'WCAG'
                };
            }
        }
        else if (wcagStandardRegex.test(tag)) {
            return {
                isValid: true,
                standard: 'WCAG'
            };
        }
        return { isValid: false };
    }
    if (/^en/i.test(tag)) {
        if (enAxeCorePattern.test(tag)) {
            const match = enAxeCorePattern.exec(tag);
            if (match) {
                const [, type, major, minor, checkpoint] = match;
                const formattedTag = `${type}.${major}.${minor}.${checkpoint}`;
                const wcagInfo = wcagData.get(`${major}.${minor}.${checkpoint}`);
                if (wcagInfo) {
                    return {
                        isValid: true,
                        checkpoint: formattedTag,
                        checkpointDescription: wcagInfo.title,
                        standard: 'EN'
                    };
                }
                return {
                    isValid: true,
                    checkpoint: formattedTag,
                    standard: 'EN'
                };
            }
        }
        else if (enDequewayPattern.test(tag)) {
            const match = enDequewayPattern.exec(tag);
            if (match) {
                const [fullMatch, major, minor, checkpoint] = match;
                const type = fullMatch.split('-')[1];
                const formattedTag = `${type}.${major}.${minor}.${checkpoint}`;
                const wcagInfo = wcagData.get(`${major}.${minor}.${checkpoint}`);
                if (wcagInfo) {
                    return {
                        isValid: true,
                        checkpoint: formattedTag,
                        checkpointDescription: wcagInfo.title,
                        standard: 'EN'
                    };
                }
                return {
                    isValid: true,
                    checkpoint: formattedTag,
                    standard: 'EN'
                };
            }
        }
        else if (enStandardPattern.test(tag)) {
            return {
                isValid: true,
                standard: 'EN'
            };
        }
        return { isValid: false };
    }
    if (tag.startsWith('TT')) {
        if (ttTagCheckoutPattern.test(tag)) {
            const match = ttTagCheckoutPattern.exec(tag);
            if (match) {
                return {
                    isValid: true,
                    checkpoint: match[1],
                    standard: 'Trusted Tester'
                };
            }
        }
        else if (ttTagStandardPattern.test(tag)) {
            return {
                isValid: true,
                standard: 'Trusted Tester'
            };
        }
        else if (ttAxeCoreCheckpointPattern.test(tag)) {
            const match = ttAxeCoreCheckpointPattern.exec(tag);
            if (match) {
                return {
                    isValid: true,
                    checkpoint: match[1],
                    standard: 'Trusted Tester'
                };
            }
        }
    }
    if (tag.startsWith('section508')) {
        const match = section508Pattern.exec(tag);
        if (match) {
            return {
                isValid: true,
                checkpoint: match[1],
                standard: 'Section 508'
            };
        }
    }
    if (tag.startsWith('RGAA')) {
        if (rgaaStandardPattern.test(tag)) {
            return {
                isValid: true,
                standard: 'RGAA'
            };
        }
        else if (rgaaAxeCoreCheckpointPattern.test(tag)) {
            const match = rgaaAxeCoreCheckpointPattern.exec(tag);
            if (match) {
                return {
                    isValid: true,
                    checkpoint: match[1],
                    standard: 'RGAA'
                };
            }
        }
    }
    return { isValid: false };
}

const validate = (value) => {
    return Object.keys(rulesets).indexOf(value) !== -1;
};

exports.androidRules = androidRules;
exports.default = rulesets;
exports.getIssueType = getIssueType;
exports.getTagInfo = getTagInfo;
exports.iosRules = iosRules;
exports.mobileRules = mobileRules;
exports.rulesets = rulesets;
exports.validate = validate;
